/**
 * Supabase client configuration.
 */

import { createClient } from "@supabase/supabase-js";
import { clearCalendarCache } from "../utils/calendarCache";

const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL;
const SUPABASE_ANON_KEY = process.env.REACT_APP_SUPABASE_ANON_KEY;

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error(
    "Missing Supabase environment variables. Set REACT_APP_SUPABASE_URL and REACT_APP_SUPABASE_ANON_KEY.",
  );
}

export const supabase = createClient(SUPABASE_URL, SUPABASE_ANON_KEY);

// The calendar keeps a copy of the member's meetings on the phone for a fast
// first paint. Signing out, from anywhere, takes it with it.
supabase.auth.onAuthStateChange((event) => {
  if (event === "SIGNED_OUT") clearCalendarCache();
});

export default supabase;
